import {
  EventCreateRequest,
  EventInfo,
  EventScenarioCreated,
  EventWithScenarios,
  ScenarioCreateRequest,
} from '../types';

import axiosInstance from './axiosInstance';

export async function getEvent(eventUuid: string) {
  const response = await axiosInstance.get(`/events/${eventUuid}`);
  return response.data as EventWithScenarios;
}

export async function getEvents() {
  const response = await axiosInstance.get('/events');
  return response.data as EventWithScenarios[];
}

export async function createEvent(event: EventCreateRequest) {
  const response = await axiosInstance.post('/events', event);
  return response.data as EventInfo;
}

export async function createEventScenario(eventUuid: string, req: ScenarioCreateRequest) {
  const response = await axiosInstance.post(`/events/${eventUuid}/scenarios`, req);
  return response.data as EventScenarioCreated;
}
